import React from 'react';
import HomeIcon from "@mui/icons-material/Home";


export default function Breadcrumb({words = []}) {
  if (!Array.isArray(words) || words.length === 0) return null;
  
  return (
    <nav aria-label="breadcrumb" className="qli-breadcrumb-nav">
      <ol className="qli-breadcrumb-list">
        {words.map((item, idx) => {
          const [word, path] = Object.entries(item)[0];
          const wordTrimmed = word.split('/').filter(Boolean).pop()
          const isLast = idx === words.length - 1;
          return (
            <li key={word} className="qli-breadcrumb-item">
              {!isLast ? (
                <>
                  <span onClick={path} className="qli-breadcrumb-link">{wordTrimmed === "Home" ?
                    <><HomeIcon fontSize="small" style={{verticalAlign: "sub", marginRight: 2}}/>Home</> :
                    wordTrimmed
                  }</span>
                  <span className="qli-breadcrumb-separator">{" > "}</span>
                </>
              ) : (
                <span className="qli-breadcrumb-current">{wordTrimmed === "Home" ?
                  <><HomeIcon fontSize="small" style={{verticalAlign: "sub", marginRight: 2}}/>Home</> :
                  wordTrimmed
                }</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
